import APIService from '.';

class NotificationService extends APIService {
  host() {
    return this.servicesHost();
  }

  get resource() {
    return `/notification-core/api/list`;
  }

  createNotifications(data: any) {
    return this.post(`/notification-core/api`, data);
  }

  seenNotifications() {
    return this.put(`/notification-core/api/seen`);
  }

  getNotifications(params: any) {
    return this.get(
      params.endpointPath
        ? `/notification-core/${params.endpointPath}`
        : this.resource,
      {
        params: params.params && this.removeEmpty(params.params)
      }
    );
  }
  readNotification(id: string) {
    return this.put(`/notifications/${id}`, { read: true });
  }
  getUnreadNotifications() {
    return this.get('/notifications?read=false');
  }
}

export default NotificationService;
